import React from 'react';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';

const DEFAULT_LIMIT_OPTIONS = [10, 20, 30, 50, 100];

export default function Pagination({ pagination, onPageChange, limit, onLimitChange, limitOptions = DEFAULT_LIMIT_OPTIONS }) {
  const { page, pages, total } = pagination;
  const showLimitSelector = typeof onLimitChange === 'function';

  if (pages <= 1 && !showLimitSelector) return null;

  const renderPageNumbers = () => {
    const items = [];
    const maxVisible = 5;

    // Logic to show a window of pages
    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = Math.min(pages, start + maxVisible - 1);

    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }

    if (start > 1) {
      items.push(1);
      if (start > 2) items.push('...');
    }

    for (let i = start; i <= end; i++) {
      items.push(i);
    }

    if (end < pages) {
      if (end < pages - 1) items.push('...');
      items.push(pages);
    }

    return items.map((item, idx) => (
      item === '...' ? (
        <span key={`dots-${idx}`} className="page-dots">...</span>
      ) : (
        <button
          key={item}
          className={`page-btn ${page === item ? 'active' : ''}`}
          onClick={() => onPageChange(item)}
        >
          {item}
        </button>
      )
    ));
  };

  return (
    <div className="pagination" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {pages > 1 && (
          <>
            <button
              className="page-btn"
              disabled={page === 1}
              onClick={() => onPageChange(page - 1)}
            >
              <MdChevronLeft size={20} />
            </button>

            {renderPageNumbers()}

            <button
              className="page-btn"
              disabled={page === pages}
              onClick={() => onPageChange(page + 1)}
            >
              <MdChevronRight size={20} />
            </button>
          </>
        )}
      </div>

      {showLimitSelector && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#6B7280' }}>
          {typeof total === 'number' && <span>{total} total</span>}
          <label htmlFor="page-limit-select" style={{ margin: 0 }}>Rows per page</label>
          <select
            id="page-limit-select"
            value={limit}
            onChange={(e) => onLimitChange(Number(e.target.value))}
            style={{ padding: '4px 8px', border: '1px solid #E5E7EB', borderRadius: 6, fontSize: 13 }}
          >
            {limitOptions.map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
}
